import { render, staticRenderFns } from "./PsPatientWeekendDetail.vue?vue&type=template&id=784c6568&"
import script from "./PsPatientWeekendDetail.vue?vue&type=script&lang=js&"
export * from "./PsPatientWeekendDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports